// extracted by mini-css-extract-plugin
export default {"module":"module_module__5nKZd","header":"module_header__TVJgE","divider":"module_divider__VlmDR"};